module.exports = __webpack_public_path__ + "static/media/b3.a1c76a1d.jpg";